import { Route, Routes } from "react-router-dom";
import Dashboard from "@/pages/dashboard";
import Layout from "@/pages/layout";
import Profile from "@/pages/perfil";
import ProfileFeedbackRegisterPage from "@/pages/feedback";
import { Routes as Path } from "@/constants/routes";
import MyProducts from "@/pages/meus-produtos";
import AddProducts from "@/pages/adicionar-produtos";
import EditProduct from "@/pages/editar-produto";

export const AppRouter = () => {
  return (
    <Routes>
      <Route element={<Layout />}>
        <Route index element={<Dashboard />} />
        <Route path={Path.PROFILE} element={<Profile />} />
        <Route path={Path.MY_PRODUCTS} element={<MyProducts />} />
        <Route path={Path.ADD_PRODUCTS} element={<AddProducts />} />
        <Route path={Path.EDIT_PRODUCT_PATTERN} element={<EditProduct />} />
        <Route path={Path.PROFILE_FEEDBACK} element={<ProfileFeedbackRegisterPage />}
        />
      </Route>
    </Routes>
  );
};
